import { render, staticRenderFns } from "./handleOnlinePlayData.vue?vue&type=template&id=79bcb246&scoped=true"
import script from "./handleOnlinePlayData.vue?vue&type=script&lang=js"
export * from "./handleOnlinePlayData.vue?vue&type=script&lang=js"
import style0 from "./handleOnlinePlayData.vue?vue&type=style&index=0&id=79bcb246&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bcb246",
  null
  
)

export default component.exports